import {
  Component,
  OnInit,
  NgZone
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AuthService } from "../core/auth/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ShareService } from "../shared/service/share.service";
import { messages } from "../shared/model/Responsemessages";
import { LoaderService } from "../shared/loader/loader.service";
import { LocationService } from "../common-layout/layout/header/location/location.service";
import { TranslateService } from "@ngx-translate/core";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MenuHorizontalService } from "../common-layout/service/menu-horizontal.service";
import { RedirectService } from "../Service/redirect.service";
import { DatePipe } from "@angular/common";
import { AppointmentToastrService } from "../shared/appointment-toastr/appointment-toastr.service";
import { WhatsappService } from "../whatsapp/whatsapp.service";
import { HttpClient } from "@angular/common/http";
import { CountryISO, SearchCountryField } from "ngx-intl-tel-input";
import { DeviceDetectorService } from "ngx-device-detector";
import { PatientSelectionComponent } from "../patient-selection/patient-selection.component";
import { FeatureAccessService } from "../shared/service/feature-access.service";
import { SessionOutService } from "../session-out/session-out.service";
import { EncryptionService } from '../utils/encryption.service';
import { WebsocketService } from "../shared/service/websocket.service";
import { CommonComponentService } from "../shared/common-component/common-component.service";
import { Capacitor } from "@capacitor/core";
import { Preferences } from '@capacitor/preferences';
import { first } from "rxjs";
import { CommonComponentComponent } from "../shared/common-component/common-component.component";
import { StorageService } from "../Service/storage.service";
import { LoginResponseHandlerService } from "../Service/login-response-handler.service";
import { McpReturnUrlService } from "../mcp/mcp-return-url.service";
import { environment } from "../../environments/environment";
import { MsalService } from '@azure/msal-angular';
import { API } from "../common/api-routes";

export enum UserRegisterType {
  Default = 0,
  Google = 1,
  Microsoft = 2,
  LinkedIn = 3,
  Facebook = 4,
  Apple = 5
}

declare const google: any;
declare const AppleID: any;
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  standalone: false
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  Email = new FormControl();
  ipAddress: string;
  ipLocation: string;
  deviceType: string;

  domain = window.location.host;
  userRole: string;
  permissionData: any;
  isMaintenance: boolean = false;
  MessageBox: string = "";
  isInTime: boolean = false;
  startTime: string;
  endTime: string;
  startDate: any;
  duration: any;
  isFirstLogin: boolean = false;
  loading: boolean = false;
  isAndroidApp = this.domain == "localhost";
  sessionId: any;
  paymentDetail: any;
  is_popup_open: boolean = false;
  redirectMenu: string = "Dashboard";
  isTwoFactorAuth: boolean = false;
  isShowUpgradePopup: any;
  selectedPlanName: any;
  expiryDate: string;
  hidePassword: boolean = true;
  isRadiologyDomain: boolean = false;
  CompanyDateFormat = localStorage.getItem('CompanyDateFormat');
  isOtpLogin: boolean = false;
  isShowGoogleLogin: boolean = false;
  isSignUp: boolean = false;
  tenantName: string = 'Plus Doctor';
  preferredCountries: CountryISO[] = [CountryISO.India, CountryISO.UnitedStates, CountryISO.Qatar];
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  selectedCountryISO: any = CountryISO.India;
  isRequiredPhoneNumber: boolean = true;
  commonDomain = environment.redirectDomainUrl;
  isCommonUrl: boolean = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService,
    private readonly router: Router,
    public shared: ShareService,
    public LoaderService: LoaderService,
    private readonly translate: TranslateService,
    public locationservice: LocationService,
    private readonly dialog: MatDialog,
    private readonly menuHorService: MenuHorizontalService,
    private readonly redirect: RedirectService,
    private readonly datePipe: DatePipe,
    private readonly toastrService: AppointmentToastrService,
    private readonly route: ActivatedRoute,
    private readonly service: WhatsappService,
    private readonly httpClient: HttpClient,
    public deviceDetectorService: DeviceDetectorService,
    public featureAccessService: FeatureAccessService,
    public sessionTimer: SessionOutService,
    private readonly encryptionService: EncryptionService,
    public wsService: WebsocketService,
    public commonComponentService: CommonComponentService,
    private readonly storageService: StorageService,
    private readonly loginResponseHandlerService: LoginResponseHandlerService,
    private readonly ngZone: NgZone,
    private readonly msalService: MsalService,
    private readonly mcpReturnUrl: McpReturnUrlService
  ) {
    this.translate.setDefaultLang("en");
    this.route.queryParams.subscribe(async (params) => {
      if (params["payment_status"] == "success") {
        this.sessionId = params["session_id"];
        this.getpaymentDetail();
        this.shared.showToast("Payment is completed", "Success");
        setTimeout(() => {
          this.AdminLoginData(params["CompanyId"]);
        }, 100);
      } else if (params["payment_status"] == "cancel") {
        this.shared.showToast("Payment is failed", "Error");
        this.router.navigate(['/']);
      }
    });
  }

  ngOnInit() {
    const currentDomain = window.location.hostname;
    console.log("Current Domain:", currentDomain);
    console.log("Common Domain:", this.commonDomain);
    console.log("condition:", currentDomain === this.commonDomain);
    if (currentDomain === this.commonDomain) {
      this.isCommonUrl = true;
    }

    window.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'linkedin-login') {
        this.ngZone.run(() => {
          this.handleLinkedInLogin(event.data.payload);
        });
      } else if (event.data && event.data.type === 'linkedin-login-error') {
        this.ngZone.run(() => {
          this.shared.showToast(event.data.error ?? "LinkedIn Login Failed", "Error");
        });
      }
    });

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/Dashboard']);
    }
    this.getUserInfo();
    this.initLoginForm();
    this.getMaintenance();
    this.isRadiologyDomain = (this.shared.domainType == 'radiology');
    this.setTenantName();

    // Manage login page stage: Open SignUp for external referrals or internal state without URL params
    this.route.queryParams.subscribe(params => {
      if (params['isSignUp'] === 'true') {
        if (!this.isSignUp) {
          this.toggleSignUp();
        }
      }
    });
  }

  getUserInfo() {
    let ip = this.storageService.getItem("IA");
    if (!ip) {
      this.redirect.getIPAddress().subscribe((x: any) => {
        const ipAddress = x.ip;
        this.ipAddress = ipAddress;
        this.storageService.setItem("IA", this.ipAddress);
      });
    } else {
      this.ipAddress = ip;
    }
    let ipLocation = this.storageService.getItem("ipLocation");
    if (!ipLocation) {
      this.httpClient
        .get<any>("https://ipinfo.io/json")
        .subscribe((data) => {
          this.ipLocation = `${data?.city}`;
          this.storageService.setItem("ipLocation", this.ipLocation)
        });
    }
    const deviceInfo = this.deviceDetectorService.getDeviceInfo();
    this.deviceType = this.getLoginDeviceType(deviceInfo.deviceType);
  }

  private getLoginDeviceType(_deviceType: string): string {
    const platform = Capacitor.getPlatform();
    if (platform === "android") {
      return "Android";
    }
    if (platform === "ios") {
      return "Ios";
    }
    const isPwa = window.matchMedia?.("(display-mode: standalone)").matches || (window.navigator as any).standalone === true;
    if (isPwa) {
      return "PWA";
    }
    return "Web";
  }
  async initLoginForm() {
    this.loginForm = this.fb.group({
      Email: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")
        ]),
      ],
      Password: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          // Validators.maxLength(100)
        ]),
      ],
      agree: [],
      Domain: this.isAndroidApp
        ? ["", Validators.compose([Validators.required])]
        : [window.location.host],
      rememberMe: [false],
      OtpEmail: [""],
      MobileNumber: [""]
    });
    if (Capacitor.isNativePlatform()) {
      const result = await Preferences.get({ key: 'loginInfo' });
      if (result.value) {
        const saved = JSON.parse(result.value);
        this.loginForm.patchValue({
          Domain: saved.domain,
          Email: saved.email,
          Password: saved.password,
          rememberMe: true
        });
      }
    }
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.loginForm.controls[controlName];
    if (!control) {
      return false;
    }
    const result =
      control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  async encryptPassword(plainText: string): Promise<string> {
    return this.encryptionService.encrypt(plainText);
  }

  async submit(form: any) {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    const userModel: any = {
      ...form.value,
      ipLocation: this.ipLocation ? this.ipLocation : null,
      ipAddress: this.ipAddress ? this.ipAddress : null,
      deviceType: this.deviceType ? this.deviceType : null,
      UserRegisterType: UserRegisterType.Default
    };

    this.storageService.setItem("MobileDomain", userModel.Domain);
    userModel.Password = await this.encryptPassword(userModel.Password);

    this.LoaderService.show();
    this.loading = true;
    this.authService.signinUser(userModel).pipe(first()).subscribe({
      next: (response: any) => {
        (async () => {
          if (response.Success === true &&
            response.Data != null &&
            response.AccessToken != null &&
            response.Data.IsOnboarded && !response.Data.IsOnboardingPaymentPending) {
            this.onBoardingUser(response);
            return;
          }
          const errorResponseCodes = [543, 105, 499, 531];

          if (response["ResponseCode"] == 105) {
            if (userModel.Password) {
              this.storageService.setItem("passwordHash", userModel.Password);
            }
            this.LoaderService.hide();
            const companyId = response.Data?.CompanyId ?? response.Data?.Id;
            const email = response.Data?.Email;
            this.storageService.setItem("email", email);
            this.router.navigate(["/OTPVerification"], {
              state: {
                Data: { Email: email, CompanyId: companyId },
                isRegistration: true
              }
            });
            return;
          }

          if (response["ResponseCode"] == 546) {
            this.storageService.setItem("email", response["Data"].email);
            this.storageService.setItem("passwordHash", userModel.Password);
            this.storageService.setItem("TwoFactorAuth", "true");
            this.storageService.setItem("isRememberMe", form.value.rememberMe);

            this.menuHorService.setPath("OTPVerification");
            this.router.navigate(["/OTPVerification"]);
            this.LoaderService.hide();
            return;
          }

          if (response["ResponseCode"] == 499 && response["AccessToken"] && response["Data"].IsOnboardingPaymentPending) {
            // Onboarding user with pending payment — authenticate and go to Dashboard
            this.shared.setOnboardUserStorage(response);
            this.storageService.setItem("IsOnboardingPaymentPending", "true");
            this.LoaderService.hide();
            this.loading = false;
            this.menuHorService.setPath("Dashboard");
            this.router.navigate(["/Dashboard"]);
            return;
          }
          else if (response["Success"] === true && (response["Data"] != null || response["UsersList"].length == 1)) {
            // Remember Me storage
            await this.rememberStorage(form);

            await this.setLocalStorage(response);

            // Default Location
            this.locationservice.getDefaultLocation(response["Data"].Id).subscribe({
              next: (res) => {
                this.handleDefaultLocation(res, response["Data"].CompanyId);
              }
            });

            // Language
            const languageData = response["Data"].LanguageCode ?? 'en';
            this.storageService.setItem("language", languageData);

            // Terms
            const termsData = {
              AgreeTerms: response["Data"].AgreeTerms,
              SkipTermsCount: response["Data"].SkipTermsCount
            };
            this.shared.setTermsInfo(termsData);

            // Feature Access
            this.featureAccessService.setFeature(response["Data"].SubscriptionAccesses);

            if (!this.storageService.getItem('sessionStart')) {
              this.sessionTimer.startSession();
            }

            // WebSocket
            this.connectWebSocket();
          }
          else if (errorResponseCodes.includes(response["ResponseCode"])) {
            // Email OTP not verified and T&C not agreed
            this.LoaderService.hide();
            this.shared.showToast(this.translate.instant(messages[response["ResponseCode"]]), "Error");
          }
          else if (response["UsersList"] && response["UsersList"].length > 1) {
            this.is_popup_open = true;
            this.dialog.open(PatientSelectionComponent, {
              data: { patientList: response["UsersList"], fromLoggedInUser: false, UserRegisterType: UserRegisterType.Default },
              disableClose: true,
            });
            this.dialog.afterAllClosed.subscribe(() => {
              this.is_popup_open = false;
            });
            sessionStorage.setItem("PatientList", JSON.stringify(response["UsersList"]));
            this.LoaderService.hide();
          }
          else {
            this.LoaderService.hide();
            this.shared.showToast(messages[response["ResponseCode"]], "Error");
          }

          this.loading = false;
        })();
      },

      error: (error) => {
        this.LoaderService.hide();
        setTimeout(() => {
          if (!this.storageService.getItem("IA")) {
            this.redirect.getIPAddress().subscribe({
              next: (x: any) => {
                const ipAddress = x.ip;
                this.ipAddress = ipAddress;
                this.storageService.setItem("IA", this.ipAddress);
              }
            });
          }
          if (error.status != 403) {
            this.shared.showToast(error?.error?.Message ?? "Something went wrong, please try again later", "Error");
          }
        }, 200);
        this.router.navigate([""]);
        this.loading = false;
      },

      complete: () => {
        // optional: cleanup or logging
      }
    });
  }

  private async rememberStorage(form: any) {
    if (Capacitor.isNativePlatform() && form.value.rememberMe) {
      await Preferences.set({
        key: 'loginInfo',
        value: JSON.stringify({
          domain: form.value.Domain,
          email: form.value.Email,
          password: form.value.Password
        })
      });
    } else {
      await Preferences.remove({ key: 'loginInfo' });
    }
  }

  private async handleDefaultLocation(res: any, companyId: number): Promise<void> {
    if (res?.Data && res.Success) {
      this.storageService.setItem(
        "Location",
        JSON.stringify({
          Id: res.Data.LocationId,
          Name: res.Data.LocationName,
        })
      );
      this.toastrService.scheduleReminders();
    }

    this.getFormat(companyId);

    await this.getGeneralSetting();
    this.shared.WPcheckWhatsAppStatus();
  }

  private async setLocalStorage(response: any): Promise<void> {
    await this.loginResponseHandlerService.setLocalStorage(response);
    const redirectMenu = response["Data"]?.RedirectMenu;
    this.redirectMenu = redirectMenu && redirectMenu.trim().length > 0 ? redirectMenu : "Dashboard";
    this.isTwoFactorAuth = response["Data"].IsTwoFactorAuth;
    this.isShowUpgradePopup = response["Data"].isShowUpgradePopup;
    this.selectedPlanName = response["Data"].SelectedPlanName
  }

  async getGeneralSetting(): Promise<void> {
    await this.shared.getLocalStorageGeneralSetting();
    this.storageService.setItem("IsShowRadiologyDomain", this.isRadiologyDomain.toString());

    const isShowExerciseGeneralSetting = this.storageService.getItem("IsShowExercise") === "true";
    let isPhysioTherapist = this.storageService.getItem("DoctorTypeName") === 'Physiotherapist';
    let isShowExercise = isShowExerciseGeneralSetting && isPhysioTherapist;
    this.storageService.setItem("IsShowExercise", isShowExercise);
  }


  async getFormat(id: any) {
    await this.shared.getCompanyByIdpromise(id).then((res) => {
      if (res["Success"] === true) {
        if (
          res["Data"]["CurrencyObj"] !== null
            ? res["Data"]["CurrencyObj"].hasOwnProperty("CurrencySymbol")
            : false
        ) {
          this.storageService.setItem(
            "Currency",
            res["Data"]["CurrencyObj"]["CurrencySymbol"]
          );
          this.storageService.setItem(
            "IsWhatsAppDisplay",
            res["Data"]["IsWhatsAppDisplay"]
          );
          this.menuHorService.setPath(this.redirectMenu);
          this.navigateAfterLogin().then(() => {
            if (this.isShowUpgradePopup) {
              this.expiryDate = this.storageService.getItem("ExpiredDate");
              const dialogRef = this.dialog.open(CommonComponentComponent, {
                disableClose: true,
                panelClass: "popup_custom_width_small",
                autoFocus: false,
                width: "70%",
                data: {
                  isShowPlanReminder: true,
                },
              });
              dialogRef.afterOpened().subscribe(() => {
                this.translate.use(this.storageService.getItem("language"));
              });
            }
          });
          this.LoaderService.hide();


        }
        else {
          this.LoaderService.hide();
          this.shared.showToast(this.translate.instant("common.errMsg"), "Error");
        }
      } else {
        this.LoaderService.hide();
        this.shared.showToast(this.translate.instant("common.errMsg"), "Error");
      }
    });
  }

  /**
   * Navigates after a successful login. When an MCP consent request was interrupted
   * by login, the user is returned to that consent URL; otherwise the normal
   * post-login destination is used, leaving every existing flow unchanged.
   */
  private navigateAfterLogin(): Promise<boolean> {
    const consentUrl = this.mcpReturnUrl.consume();
    if (consentUrl) {
      return this.router.navigateByUrl(consentUrl);
    }
    return this.router.navigate([this.redirectMenu]);
  }

  getpaymentDetail() {
    this.service
      .getpaymentDetailforsignup(this.sessionId, 2)
      .subscribe((response) => {
        if (response === true) {
          this.paymentDetail = response["Data"];
        }
      });
  }

  AdminLoginData(data: any) {
    this.redirect.AdminLoginData(data).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.storageService.setItem("clickhere", JSON.stringify(true));
          this.storageService.setItem("token", res["AccessToken"]);
          console.log("HTTTP Login");
          this.storageService.setItem("Name", res["Data"].Name);
          this.storageService.setItem("userId", res["Data"].Id);
          this.storageService.setItem("companyId", res["Data"].CompanyId);
          this.storageService.setItem("CompanyName", res["Data"].CompanyName);
          this.storageService.setItem("DoctorTypeId", res["Data"].DoctorTypeId);
          this.storageService.setItem("DoctorTypeName", res["Data"].DoctorTypeObj ? res["Data"].DoctorTypeObj.DoctorTypeName : "");
          this.storageService.setItem("UserName", res["Data"].UserName);
          this.storageService.setItem("Email", res["Data"].Email);

          this.storageService.setItem(
            "selectedPlan",
            res["Data"].selectedPlan ? res["Data"].selectedPlan : "5"
          );
          this.storageService.setItem(
            "Location",
            JSON.stringify({
              Id: res["Data"].LocationId,
              Name: res["Data"].LocationName,
            })
          );
          this.storageService.setItem("AspNetRole", res["Data"].AspNetRoleList);
          this.storageService.setItem("IsFirst", res["Data"].IsFirst);
          this.storageService.setItem("IsTour", res["Data"].IsTour);
          this.redirect.getDefaultLocation(res["Data"].Id).subscribe({
            next: (response: any) => {
              if (response["Data"] != null && response["Success"] === true) {
                this.storageService.setItem(
                  "Location",
                  JSON.stringify({
                    Id: res["Data"].LocationId,
                    Name: res["Data"].LocationName,
                  })
                );
              }
              this.getFormat(res["Data"].CompanyId);
            },
          });
        } else {
          this.shared.showToast(
            "Something went wrong in the login process sorry",
            "Error"
          );
        }
      },
      error: () => {
        this.shared.showToast(
          "Something went wrong in the login process sorry",
          "Error"
        );
      },
    });
  }
  getMaintenance() {
    this.redirect.getMaintenance().subscribe((res: any) => {
      if (res.Success) {
        const timeParts = res.Data[0].StartTime.split(":");
        const hours = parseInt(timeParts[0], 10);
        let formattedHours = hours % 12;
        formattedHours = formattedHours === 0 ? 12 : formattedHours;
        const minutes = timeParts[1];
        const period = hours >= 12 ? "PM" : "AM";
        this.startTime = `${formattedHours}:${minutes} ${period}`;

        const EtimeParts = res.Data[0].EndTime.split(":");
        const Ehours = parseInt(EtimeParts[0], 10);
        let EformattedHours = Ehours % 12;
        EformattedHours = EformattedHours === 0 ? 12 : EformattedHours;
        const Eminutes = EtimeParts[1];
        const Eperiod = Ehours >= 12 ? "PM" : "AM";
        this.endTime = `${EformattedHours}:${Eminutes} ${Eperiod}`;
        this.isMaintenance = res.Data[0].IsMaintenance;
        this.MessageBox = res.Data[0].MessageBox;
        this.startDate = res.Data[0].StartDate;
        this.duration = this.calculateDuration(
          res.Data[0].StartTime,
          res.Data[0].EndTime
        );
        this.MessageBox = res.Data[0].MessageBox.replace(
          "[Date]",
          this.datePipe.transform(this.startDate, "dd/MM/yyyy")
        )
          .replace("[Start Time]", this.startTime)
          .replace("[End Time]", `${this.endTime} (IST - Indian Standard Time)`)
          .replace("[Duration]", this.duration);

        if (
          this.isDateBetween(
            res.Data[0].StartDate,
            res.Data[0].EndDate,
            new Date()
          )
        ) {
          let newDate = new Date().toISOString().split("T")[0];
          let endDate = res.Data[0].EndDate.split("T")[0];
          if (newDate == endDate) {
            if (
              this.isCurrentTimeInRange(
                res.Data[0].StartTime,
                res.Data[0].EndTime
              )
            ) {
              this.isInTime = true;
            } else {
              this.isInTime = false;
            }
          } else {
            this.isInTime = true;
          }
        } else {
          this.isInTime = false;
        }
      }
    });
  }
  isDateBetween(start, end, check): boolean {
    let newDate = check.toISOString().split("T")[0];
    let startDate = start.split("T")[0];
    let endDate = end.split("T")[0];

    let newStartDate = new Date(start);
    let updatedStartDate = new Date(newStartDate);
    updatedStartDate.setDate(newStartDate.getDate() - 1);

    return newDate >= startDate && newDate <= endDate;
  }
  isCurrentTimeInRange(startTime: string, endTime: string): boolean {
    const now = new Date(); // Get the current time
    const [startHours, startMinutes] = startTime.split(":");
    const [endHours, endMinutes] = endTime.split(":");
    const startDate = new Date();
    startDate.setHours(Number(startHours));
    startDate.setMinutes(Number(startMinutes));
    const endDate = new Date();
    endDate.setHours(Number(endHours));
    endDate.setMinutes(Number(endMinutes));

    return now <= endDate;
  }
  calculateDuration(startTime: string, endTime: string): string {
    const start = this.parseTime(startTime);
    const end = this.parseTime(endTime);
    const durationMilliseconds = end.getTime() - start.getTime();
    const hours = Math.floor(durationMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor(
      (durationMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
    );
    const formattedHours = this.padZero(hours);
    const formattedMinutes = this.padZero(minutes);

    return `${formattedHours} Hours ${formattedMinutes} Minutes`;
  }

  parseTime(timeString: string): Date {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const date = new Date();
    date.setHours(hours, minutes, seconds);
    return date;
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  connectWebSocket(): void {
    const data = this.authService.getWebScoketData();
    if (data) {
      this.wsService.connect(data.userId, data.companyId);
      this.wsService.onForceLogout((reason) => {
        this.commonComponentService.startLogout(reason);
      });
    }
  }

  toggleOtpLogin() {
    this.isOtpLogin = !this.isOtpLogin;
    const userNameControl = this.loginForm.get('Email');
    const passwordControl = this.loginForm.get('Password');
    const otpEmailControl = this.loginForm.get('OtpEmail');

    if (this.isOtpLogin) {
      userNameControl.clearValidators();
      passwordControl.clearValidators();
      otpEmailControl.setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]);
    } else {
      userNameControl.setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]);
      passwordControl.setValidators([Validators.required, Validators.minLength(6)]);
      otpEmailControl.clearValidators();
    }
    userNameControl.updateValueAndValidity();
    passwordControl.updateValueAndValidity();
    otpEmailControl.updateValueAndValidity();
  }

  sendOtp() {
    if (this.loginForm.get('OtpEmail').invalid) {
      this.loginForm.get('OtpEmail').markAsTouched();
      return;
    }
    this.loading = true;
    this.LoaderService.show();
    const email = this.loginForm.get('OtpEmail').value;
    this.authService.sendLoginOtp(email).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.LoaderService.hide();
        if (res.Success) {
          this.shared.showToast(res.Message ?? "OTP sent successfully", "Success");
          this.storageService.setItem("email", email);
          this.storageService.setItem("isOtpLogin", "true");
          this.router.navigate(["/OTPVerification"], { state: { Data: { Email: email }, isOtpLogin: true } });
        } else {
          this.LoaderService.hide();
          this.shared.showToast(messages[res["ResponseCode"]], "Error");
        }
      },
      error: (err) => {
        this.loading = false;
        this.LoaderService.hide();
        this.shared.showToast(err.error?.Message ?? "Something went wrong", "Error");
      }
    });
  }


  loginWithGoogle() {
    // Use hash routing format
    const redirectUrl = window.location.protocol + "//" + window.location.host + "/#/Login";
    this.LoaderService.show();
    this.authService.getGoogleAuthUrl(redirectUrl).subscribe({
      next: (res: any) => {
        this.LoaderService.hide();
        if (res?.Url) {
          window.location.href = res.Url;
        } else {
          this.shared.showToast("Failed to initiate Google Login", "Error");
        }
      },
      error: (err) => {
        this.LoaderService.hide();
        this.shared.showToast("Something went wrong", "Error");
      }
    });
  }

  toggleSignUp() {
    this.isSignUp = !this.isSignUp;
    this.isOtpLogin = false;
    const userNameControl = this.loginForm.get('Email');
    const passwordControl = this.loginForm.get('Password');
    const mobileControl = this.loginForm.get('MobileNumber');

    if (this.isSignUp) {
      userNameControl.setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]);
      mobileControl.setValidators([Validators.required]);
    } else {
      userNameControl.setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]);
      mobileControl.clearValidators();
      mobileControl.setErrors(null);
    }
    userNameControl.updateValueAndValidity();
    passwordControl.updateValueAndValidity();
    mobileControl.updateValueAndValidity();
  }

  onPhoneNumberKeyup() {
    const phoneControl = this.loginForm.controls['MobileNumber'];
    const errors = { ...phoneControl.errors };
    if (errors?.validatePhoneNumber?.valid === false) {
      phoneControl.setErrors({ ...errors, invalidPhone: true });
    } else if (errors?.invalidPhone) {
      delete errors.invalidPhone;
      phoneControl.setErrors(Object.keys(errors).length > 0 ? errors : null);
    }
  }

  onCountrySearch(event: any): void {
    const searchInput = event.target as HTMLInputElement;
    const elementId = searchInput.id;

    if (elementId && elementId === 'country-search-box') {
      const searchTerm = searchInput.value.toLowerCase();
      const countryListItems = document.querySelectorAll('.iti__country');
      let matchFound = false;

      countryListItems.forEach((item: any) => {
        const countryName = item.innerText.toLowerCase();
        if (countryName.includes(searchTerm)) {
          item.style.display = 'block';
          matchFound = true;
        } else {
          item.style.display = 'none';
        }
      });
      let noMatchElement = document.querySelector<HTMLElement>('.iti__no-matches');

      if (!noMatchElement) {
        noMatchElement = document.createElement('div');
        noMatchElement.className = 'iti__no-matches';
        noMatchElement.style.padding = '10px';
        noMatchElement.style.textAlign = 'center';
        noMatchElement.style.color = '#999';
        noMatchElement.textContent = this.translate.instant("common.No records available.");
        const countryList = document.querySelector('.iti__country-list');
        if (countryList) {
          countryList.appendChild(noMatchElement);
        }
      }
      noMatchElement.style.display = matchFound ? 'none' : 'block';
    }
  }

  async signUp() {
    this.onPhoneNumberKeyup();
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    this.loading = true;
    this.LoaderService.show();

    const formValue = this.loginForm.value;
    let mobileNumber = formValue.MobileNumber?.e164Number ?? formValue.MobileNumber?.number ?? formValue.MobileNumber;
    if (formValue.MobileNumber?.dialCode) {
      mobileNumber = mobileNumber.replace(formValue.MobileNumber.dialCode, "");
    }

    const model = {
      Email: formValue.Email,
      MobileNumber: mobileNumber,
      CountryCode: formValue.MobileNumber?.dialCode,
      Password: await this.encryptPassword(formValue.Password),
      IPAddress: this.ipAddress ?? '0',
      IPLocation: this.ipLocation ?? ''
    };

    this.authService.signUp(model).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.LoaderService.hide();
        if (res.Success) {
          const companyId = res.Data.Id;
          const email = model.Email;
          this.storageService.setItem("passwordHash", model.Password);
          this.storageService.setItem("email", email);
          this.router.navigate(["/OTPVerification"], { state: { Data: { Email: email, CompanyId: companyId }, isRegistration: true } });
        } else {
          this.shared.showToast(res.Message ?? "Registration failed", "Error");
        }
      },
      error: (err) => {
        this.loading = false;
        this.LoaderService.hide();
        this.shared.showToast(err.error?.Message ?? "Something went wrong", "Error");
      }
    });
  }

  checkUserExists() {
    const emailControl = this.loginForm.get('Email');
    const email = emailControl.value;
    if (this.isSignUp && email && emailControl.valid) {
      this.authService.checkUserExist(email).subscribe((res: any) => {
        if (!res.Success) {
          emailControl.setErrors({ ...emailControl.errors, userExists: true });
        } else {
          const errors = { ...emailControl.errors };
          delete errors['userExists'];
          emailControl.setErrors(Object.keys(errors).length > 0 ? errors : null);
        }
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initializeGoogleLogin();
    }, 500);
  }

  initializeGoogleLogin() {
    if (typeof google !== 'undefined') {
      google.accounts.id.initialize({
        client_id: environment.googleClientId,
        callback: (response: any) =>
          this.ngZone.run(() => this.handleGoogleLogin(response))
      });

      google.accounts.id.renderButton(
        document.getElementById('googleBtn'),
        {
          theme: 'outline',
          size: 'large'
        }
      );
    }
  }

  triggerGoogleLogin() {
    const googleButton =
      document.querySelector('#googleBtn div[role=button]') as HTMLElement;

    googleButton?.click();
  }
  async handleGoogleLogin(response: any) {
    if (response.credential) {
      const payload = JSON.parse(atob(response.credential.split('.')[1]));
      const userEmail = payload.email;
      const userName = payload.name;
      const firstName = payload.given_name;
      const lastName = payload.family_name;

      const userModel: any = {
        googleToken: response.credential,
        Email: userEmail,
        Name: userName,
        FirstName: firstName,
        LastName: lastName,
        ipLocation: this.ipLocation ? this.ipLocation : null,
        ipAddress: this.ipAddress ? this.ipAddress : null,
        deviceType: this.deviceType ? this.deviceType : null,
        password: response.credential,
        domain: window.location.host,
        UserRegisterType: UserRegisterType.Google
      };

      this.LoaderService.show();
      this.loading = true;

      this.httpClient.post(`${environment.endPoint}api/User/GoogleSignin`, userModel).subscribe({
        next: (res: any) => {
          if (res.Success === true &&
            res.Data != null &&
            res.AccessToken != null &&
            res.Data.IsOnboarded === true) {
            this.shared.setOnboardUserStorage(res);
            this.LoaderService.hide();
            this.loading = false;
            this.menuHorService.setPath("Dashboard");
            this.router.navigate(["/Dashboard"]);
            return;
          }
          if (res["ResponseCode"] == 499 && res["AccessToken"] && res["Data"].IsOnboardingPaymentPending) {
            // Onboarding user with pending payment — authenticate and go to Dashboard
            this.shared.setOnboardUserStorage(res);
            this.storageService.setItem("IsOnboardingPaymentPending", "true");
            this.LoaderService.hide();
            this.loading = false;
            this.menuHorService.setPath("Dashboard");
            this.router.navigate(["/Dashboard"]);
            return;
          }
          if (res.Success && (res["Data"] != null || res["UsersList"].length == 1)) {
            this.setLocalStorage(res).then(() => {
              this.initializeSession(res);
            });
          } else if (res.ResponseCode === 409 || res.ResponseCode === 421) {
            this.shared.showToast("User not found. Please register your account.", "Info");
            this.router.navigate(['/Redirect'], { queryParams: { email: res.Data?.Email ?? '' } });
          } else if (res["UsersList"] && res["UsersList"].length > 1) {
            this.is_popup_open = true;
            this.dialog.open(PatientSelectionComponent, {
              data: { patientList: res["UsersList"], fromLoggedInUser: false, UserRegisterType: UserRegisterType.Google },
              disableClose: true,
            });
            this.dialog.afterAllClosed.subscribe(() => {
              this.is_popup_open = false;
            });
            sessionStorage.setItem("PatientList", JSON.stringify(res["UsersList"]));
            this.LoaderService.hide();
          } else {
            this.shared.showToast(res.Message ?? "Google login failed", "Error");
          }
          this.LoaderService.hide();
          this.loading = false;
        },
        error: (err) => {
          this.LoaderService.hide();
          this.loading = false;
          this.shared.showToast("Something went wrong with Google Login", "Error");
        }
      });
    }
  }
  private initializeSession(response: any): void {
    // Default Location
    this.locationservice.getDefaultLocation(response["Data"].Id).subscribe({
      next: (res) => {
        this.handleDefaultLocation(res, response["Data"].CompanyId);
      }
    });

    // Language
    const languageData = response["Data"].LanguageCode ?? 'en';
    this.storageService.setItem("language", languageData);

    // Terms
    const termsData = {
      AgreeTerms: response["Data"].AgreeTerms,
      SkipTermsCount: response["Data"].SkipTermsCount
    };
    this.shared.setTermsInfo(termsData);

    // Feature Access
    this.featureAccessService.setFeature(response["Data"].SubscriptionAccesses);

    if (!this.storageService.getItem('sessionStart')) {
      this.sessionTimer.startSession();
    }

    // WebSocket
    this.connectWebSocket();
  }

  onBoardingUser(response: any) {
    if (response["ResponseCode"] == 105) {
      const companyId = response.Data.Id;
      const email = response.Data.Email;
      this.storageService.setItem("email", email);
      this.router.navigate(["/OTPVerification"], { state: { Data: { Email: email, CompanyId: companyId }, isRegistration: true } });
    } else {
      this.shared.setOnboardUserStorage(response);
      this.LoaderService.hide();
      this.loading = false;
      this.menuHorService.setPath("Dashboard");
      this.router.navigate(["/Dashboard"]);
    }
  }

  setTenantName() {
    if (this.shared.domainType === 'physio') this.tenantName = 'Plus Physio';
    else if (this.shared.domainType === 'radiology') this.tenantName = 'Plus Radiology';
    else this.tenantName = 'Plus Doctor';
  }

  loginWithLinkedIn() {
    const clientId = environment.linkedinClientId;
    const redirectUri = encodeURIComponent(`${environment.endPoint}${API.PlusDoctor_SignIn.linkdinCallback}`);

    const width = 600;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=openid%20profile%20email&state=popup`;

    window.open(url, 'LinkedInLogin', `width=${width},height=${height},top=${top},left=${left}`);
  }

  async handleLinkedInLogin(linkedinData: any) {
    const userModel: any = {
      Email: linkedinData.email,
      FirstName: linkedinData.firstName,
      LastName: linkedinData.lastName,
      Password: linkedinData.token,
      domain: window.location.host,
      UserRegisterType: UserRegisterType.LinkedIn,
      ipLocation: this.ipLocation ? this.ipLocation : null,
      ipAddress: this.ipAddress ? this.ipAddress : null,
      deviceType: this.deviceType ? this.deviceType : null,
    };

    this.LoaderService.show();
    this.loading = true;

    this.httpClient.post(`${environment.endPoint}${API.PlusDoctor_SignIn.linkdinSignin}`, userModel).subscribe({
      next: (res: any) => {
        if (res.Success === true &&
          res.Data != null &&
          res.AccessToken != null &&
          res.Data.IsOnboarded === true) {
          this.shared.setOnboardUserStorage(res);
          this.LoaderService.hide();
          this.loading = false;
          this.menuHorService.setPath("Dashboard");
          this.router.navigate(["/Dashboard"]);
          return;
        }
        if (res["ResponseCode"] == 499 && res["AccessToken"] && res["Data"].IsOnboardingPaymentPending) {
          this.shared.setOnboardUserStorage(res);
          this.storageService.setItem("IsOnboardingPaymentPending", "true");
          this.LoaderService.hide();
          this.loading = false;
          this.menuHorService.setPath("Dashboard");
          this.router.navigate(["/Dashboard"]);
          return;
        }
        if (res.Success && (res["Data"] != null || res["UsersList"].length == 1)) {
          this.setLocalStorage(res).then(() => {
            this.initializeSession(res);
          });
        } else if (res.ResponseCode === 409 || res.ResponseCode === 421) {
          this.shared.showToast("User not found. Please register your account.", "Info");
          this.router.navigate(['/Redirect'], { queryParams: { email: res.Data?.Email ?? '' } });
        } else if (res["UsersList"] && res["UsersList"].length > 1) {
          this.is_popup_open = true;
          this.dialog.open(PatientSelectionComponent, {
            data: { patientList: res["UsersList"], fromLoggedInUser: false, UserRegisterType: UserRegisterType.LinkedIn },
            disableClose: true,
          });
          this.dialog.afterAllClosed.subscribe(() => {
            this.is_popup_open = false;
          });
          sessionStorage.setItem("PatientList", JSON.stringify(res["UsersList"]));
          this.LoaderService.hide();
        } else {
          this.shared.showToast(res.Message ?? "LinkedIn login failed", "Error");
        }
        this.LoaderService.hide();
        this.loading = false;
      },
      error: (err) => {
        this.LoaderService.hide();
        this.loading = false;
        this.shared.showToast("Something went wrong with LinkedIn Login", "Error");
      }
    });
  }

  loginWithMicrosoft() {
    this.LoaderService.show();
    this.loading = true;
    this.msalService.initialize().subscribe({
      next: () => {
        this.msalService.loginPopup().subscribe({
          next: (response: any) => {
            const userEmail = response.account.username;
            const accessToken = response.idToken ?? response.accessToken;
            const userName = response.account.name;
            const nameParts = (userName ?? '').split(' ');
            const firstName = nameParts[0] ?? '';
            const lastName = nameParts.slice(1).join(' ') ?? '';

            const userModel: any = {
              MicrosoftToken: accessToken,
              Email: userEmail,
              UserName: userEmail,
              FirstName: firstName,
              LastName: lastName,
              ipLocation: this.ipLocation ? this.ipLocation : null,
              ipAddress: this.ipAddress ? this.ipAddress : null,
              deviceType: this.deviceType ? this.deviceType : null,
              password: accessToken,
              domain: window.location.host,
              UserRegisterType: UserRegisterType.Microsoft
            };

            this.microsoftLogin(userModel);
          },
          error: (err: any) => {
            this.LoaderService.hide();
            this.loading = false;
            console.error("Microsoft popup login error: ", err);
            if (err.errorCode !== 'user_cancelled') {
              this.shared.showToast("Microsoft login was cancelled or failed", "Error");
            }
          }
        });
      },
      error: (err: any) => {
        this.LoaderService.hide();
        this.loading = false;
        console.error("MSAL initialization error: ", err);
        this.shared.showToast("Failed to initialize Microsoft login client", "Error");
      }
    });
  }

  microsoftLogin(userModel: any) {
    this.httpClient.post(`${environment.endPoint}${API.PlusDoctor_SignIn.microsoftSignin}`, userModel).subscribe({
      next: (res: any) => {
        if (res.Success === true &&
          res.Data != null &&
          res.AccessToken != null &&
          res.Data.IsOnboarded === true) {
          this.shared.setOnboardUserStorage(res);
          this.LoaderService.hide();
          this.loading = false;
          this.menuHorService.setPath("Dashboard");
          this.router.navigate(["/Dashboard"]);
          return;
        }
        if (res["ResponseCode"] == 499 && res["AccessToken"] && res["Data"].IsOnboardingPaymentPending) {
          this.shared.setOnboardUserStorage(res);
          this.storageService.setItem("IsOnboardingPaymentPending", "true");
          this.LoaderService.hide();
          this.loading = false;
          this.menuHorService.setPath("Dashboard");
          this.router.navigate(["/Dashboard"]);
          return;
        }
        if (res.Success && (res["Data"] != null || res["UsersList"].length == 1)) {
          this.setLocalStorage(res).then(() => {
            this.initializeSession(res);
          });
        } else if (res.ResponseCode === 409 || res.ResponseCode === 421) {
          this.shared.showToast("User not found. Please register your account.", "Info");
          this.router.navigate(['/Redirect'], { queryParams: { email: res.Data?.Email ?? '' } });
        } else if (res["UsersList"] && res["UsersList"].length > 1) {
          this.is_popup_open = true;
          this.dialog.open(PatientSelectionComponent, {
            data: { patientList: res["UsersList"], fromLoggedInUser: false, UserRegisterType: UserRegisterType.Microsoft },
            disableClose: true,
          });
          this.dialog.afterAllClosed.subscribe(() => {
            this.is_popup_open = false;
          });
          sessionStorage.setItem("PatientList", JSON.stringify(res["UsersList"]));
          this.LoaderService.hide();
        } else {
          this.shared.showToast(res.Message ?? "Microsoft login failed", "Error");
        }
        this.LoaderService.hide();
        this.loading = false;
      },
      error: (err) => {
        this.LoaderService.hide();
        this.loading = false;
        this.shared.showToast("Something went wrong with Microsoft Login", "Error");
      }
    });
  }

  loadFacebookSDK(): Promise<void> {
    return new Promise((resolve) => {
      if ((window as any).FB) {
        resolve();
        return;
      }
      (window as any).fbAsyncInit = () => {
        (window as any).FB.init({
          appId: environment.facebookAppId,
          cookie: true,
          xfbml: true,
          version: 'v16.0'
        });
        resolve();
      };

      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    });
  }

  loginWithFacebook() {
    this.LoaderService.show();
    this.loading = true;
    this.loadFacebookSDK().then(() => {
      (window as any).FB.login((response: any) => {
        if (response.authResponse) {
          const accessToken = response.authResponse.accessToken;
          (window as any).FB.api('/me', { fields: 'name,first_name,last_name,email' }, (userInfo: any) => {
            const userEmail = userInfo.email || '';
            const userName = userInfo.name || '';
            const firstName = userInfo.first_name || '';
            const lastName = userInfo.last_name || '';

            const userModel: any = {
              FacebookToken: accessToken,
              Email: userEmail,
              UserName: userEmail,
              FirstName: firstName,
              LastName: lastName,
              ipLocation: this.ipLocation ? this.ipLocation : null,
              ipAddress: this.ipAddress ? this.ipAddress : null,
              deviceType: this.deviceType ? this.deviceType : null,
              password: accessToken,
              domain: window.location.host,
              UserRegisterType: UserRegisterType.Facebook
            };

            this.facebookLogin(userModel);
          });
        } else {
          this.LoaderService.hide();
          this.loading = false;
        }
      }, { scope: 'email,public_profile' });
    }).catch(err => {
      this.LoaderService.hide();
      this.loading = false;
      console.error("Facebook SDK load error: ", err);
      this.shared.showToast("Failed to initialize Facebook login client", "Error");
    });
  }

  facebookLogin(userModel: any) {
    this.httpClient.post(`${environment.endPoint}${API.PlusDoctor_SignIn.facebookSignin}`, userModel).subscribe({
      next: (res: any) => {
        if (res.Success === true &&
          res.Data != null &&
          res.AccessToken != null &&
          res.Data.IsOnboarded === true) {
          this.shared.setOnboardUserStorage(res);
          this.LoaderService.hide();
          this.loading = false;
          this.menuHorService.setPath("Dashboard");
          this.router.navigate(["/Dashboard"]);
          return;
        }
        if (res["ResponseCode"] == 499 && res["AccessToken"] && res["Data"].IsOnboardingPaymentPending) {
          this.shared.setOnboardUserStorage(res);
          this.storageService.setItem("IsOnboardingPaymentPending", "true");
          this.LoaderService.hide();
          this.loading = false;
          this.menuHorService.setPath("Dashboard");
          this.router.navigate(["/Dashboard"]);
          return;
        }
        if (res.Success && (res["Data"] != null || res["UsersList"].length == 1)) {
          this.setLocalStorage(res).then(() => {
            this.initializeSession(res);
          });
        } else if (res.ResponseCode === 409 || res.ResponseCode === 421) {
          this.shared.showToast("User not found. Please register your account.", "Info");
          this.router.navigate(['/Redirect'], { queryParams: { email: res.Data?.Email ?? '' } });
        } else if (res["UsersList"] && res["UsersList"].length > 1) {
          this.is_popup_open = true;
          this.dialog.open(PatientSelectionComponent, {
            data: { patientList: res["UsersList"], fromLoggedInUser: false, UserRegisterType: UserRegisterType.Facebook },
            disableClose: true,
          });
          this.dialog.afterAllClosed.subscribe(() => {
            this.is_popup_open = false;
          });
          sessionStorage.setItem("PatientList", JSON.stringify(res["UsersList"]));
          this.LoaderService.hide();
        } else {
          this.shared.showToast(res.Message ?? "Facebook login failed", "Error");
        }
        this.LoaderService.hide();
        this.loading = false;
      },
      error: (err) => {
        this.LoaderService.hide();
        this.loading = false;
        this.shared.showToast("Something went wrong with Facebook Login", "Error");
      }
    });
  }

  loadAppleSDK(): Promise<void> {
    return new Promise((resolve) => {
      if (typeof AppleID !== 'undefined') {
        resolve();
        return;
      }
      const existingScript = document.getElementById('apple-auth-js');
      if (existingScript) {
        const checkInterval = setInterval(() => {
          if (typeof AppleID !== 'undefined') {
            clearInterval(checkInterval);
            resolve();
          }
        }, 100);
        setTimeout(() => {
          clearInterval(checkInterval);
          resolve();
        }, 5000);
        return;
      }
      const script = document.createElement('script');
      script.id = 'apple-auth-js';
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve();
      };
      script.onerror = (err) => {
        console.error("Failed to load Apple SDK", err);
        resolve();
      };
      document.body.appendChild(script);
    });
  }

  loginWithApple() {
    this.LoaderService.show();
    this.loading = true;
    this.loadAppleSDK().then(() => {
      if (typeof AppleID === 'undefined') {
        this.LoaderService.hide();
        this.loading = false;
        this.shared.showToast("Failed to load Apple Sign In client", "Error");
        return;
      }
      try {
        AppleID.auth.init({
          clientId: environment.appleClientId,
          scope: 'name email',
          redirectURI: window.location.origin,
          usePopup: true
        });

        AppleID.auth.signIn().then((response: any) => {
          this.ngZone.run(() => {
            if (response && response.authorization) {
              const idToken = response.authorization.id_token;
              
              let userEmail = '';
              let firstName = '';
              let lastName = '';
              
              if (response.user) {
                userEmail = response.user.email ?? '';
                firstName = response.user.name?.firstName ?? '';
                lastName = response.user.name?.lastName ?? '';
              }
              
              if (!userEmail && idToken) {
                try {
                  const payload = JSON.parse(atob(idToken.split('.')[1]));
                  userEmail = payload.email ?? '';
                } catch (e) {
                  console.error("Error decoding Apple ID token:", e);
                }
              }

              const userModel: any = {
                AppleToken: idToken,
                Email: userEmail,
                UserName: userEmail,
                FirstName: firstName,
                LastName: lastName,
                ipLocation: this.ipLocation ? this.ipLocation : null,
                ipAddress: this.ipAddress ? this.ipAddress : null,
                deviceType: this.deviceType ? this.deviceType : null,
                password: idToken,
                domain: window.location.host,
                UserRegisterType: UserRegisterType.Apple
              };

              this.appleLogin(userModel);
            } else {
              this.LoaderService.hide();
              this.loading = false;
              this.shared.showToast("Apple login was cancelled or failed", "Error");
            }
          });
        }).catch((err: any) => {
          this.ngZone.run(() => {
            this.LoaderService.hide();
            this.loading = false;
            console.error("Apple Sign In error: ", err);
            if (err.error !== 'popup_closed_by_user') {
              this.shared.showToast("Apple login failed", "Error");
            }
          });
        });
      } catch (err: any) {
        this.LoaderService.hide();
        this.loading = false;
        console.error("Apple Sign In initialization failed: ", err);
        this.shared.showToast("Apple login initialization failed", "Error");
      }
    });
  }

  appleLogin(userModel: any) {
    this.httpClient.post(`${environment.endPoint}${API.PlusDoctor_SignIn.appleSignin}`, userModel).subscribe({
      next: (res: any) => {
        if (res.Success === true &&
          res.Data != null &&
          res.AccessToken != null &&
          res.Data.IsOnboarded === true) {
          this.shared.setOnboardUserStorage(res);
          this.LoaderService.hide();
          this.loading = false;
          this.menuHorService.setPath("Dashboard");
          this.router.navigate(["/Dashboard"]);
          return;
        }
        if (res["ResponseCode"] == 499 && res["AccessToken"] && res["Data"].IsOnboardingPaymentPending) {
          this.shared.setOnboardUserStorage(res);
          this.storageService.setItem("IsOnboardingPaymentPending", "true");
          this.LoaderService.hide();
          this.loading = false;
          this.menuHorService.setPath("Dashboard");
          this.router.navigate(["/Dashboard"]);
          return;
        }
        if (res.Success && (res["Data"] != null || res["UsersList"].length == 1)) {
          this.setLocalStorage(res).then(() => {
            this.initializeSession(res);
          });
        } else if (res.ResponseCode === 409 || res.ResponseCode === 421) {
          this.shared.showToast("User not found. Please register your account.", "Info");
          this.router.navigate(['/Redirect'], { queryParams: { email: res.Data?.Email ?? '' } });
        } else if (res["UsersList"] && res["UsersList"].length > 1) {
          this.is_popup_open = true;
          this.dialog.open(PatientSelectionComponent, {
            data: { patientList: res["UsersList"], fromLoggedInUser: false, UserRegisterType: UserRegisterType.Apple },
            disableClose: true,
          });
          this.dialog.afterAllClosed.subscribe(() => {
            this.is_popup_open = false;
          });
          sessionStorage.setItem("PatientList", JSON.stringify(res["UsersList"]));
          this.LoaderService.hide();
        } else {
          this.shared.showToast(res.Message ?? "Apple login failed", "Error");
        }
        this.LoaderService.hide();
        this.loading = false;
      },
      error: (err) => {
        this.LoaderService.hide();
        this.loading = false;
        this.shared.showToast("Something went wrong with Apple Login", "Error");
      }
    });
  }

}
